import { animate, animateChild, group, query, style, transition } from '@angular/animations';

export const dialogInner = [
  transition(':enter', [
    style({
      opacity: 0,
    }),
    group([query('*', animateChild()), animate('0.6s cubic-bezier(0.25, 1, 0.5, 1)', style({ opacity: 1 }))]),
  ]),
];
